import React from 'react';
import { Crown, Check, ArrowRight, Users, Target, Briefcase, DollarSign, Megaphone } from 'lucide-react';
import { motion } from 'framer-motion';
export function LeadershipPage() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-687">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-688">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-689" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-690">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-691">
            Executive Recruiting
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-692">
            HIRE Leadership
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-693">
            For companies that need to recruit leadership-level talent to scale
            their D2D and home services operation.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-694">
            Finding managers and team leaders requires a different approach. We
            build and run targeted campaigns to attract the leaders who will
            drive your team's growth.
          </p>
        </motion.div>
      </section>

      {/* 2. CAMPAIGN PRICING */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-695">
        <div className="text-center mb-16" data-id="element-696">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-697">
            Campaign Structure
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-698">
            Transparent pricing to build and run your leadership recruiting
            engine.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-699">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8 text-center flex flex-col items-center" data-id="element-700">
            <div className="w-14 h-14 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mb-6" data-id="element-701">
              <Briefcase className="w-7 h-7 text-[#7FE0C3]" data-id="element-702" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-703">$1,000</h3>
            <p className="text-[#7FE0C3] font-medium mb-4" data-id="element-704">
              One-Time Build Fee
            </p>
            <p className="text-slate-400 text-sm" data-id="element-705">
              Complete creation and setup of your targeted leadership recruiting
              campaign.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8 text-center flex flex-col items-center" data-id="element-706">
            <div className="w-14 h-14 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mb-6" data-id="element-707">
              <Target className="w-7 h-7 text-[#7FE0C3]" data-id="element-708" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-709">$1,000</h3>
            <p className="text-[#7FE0C3] font-medium mb-4" data-id="element-710">Per Month</p>
            <p className="text-slate-400 text-sm" data-id="element-711">
              Active management, optimization, and running of the campaign.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8 text-center flex flex-col items-center" data-id="element-712">
            <div className="w-14 h-14 rounded-full bg-[#7FE0C3]/10 flex items-center justify-center mb-6" data-id="element-713">
              <Megaphone className="w-7 h-7 text-[#7FE0C3]" data-id="element-714" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-715">Ad Spend</h3>
            <p className="text-[#7FE0C3] font-medium mb-4" data-id="element-716">Client Funded</p>
            <p className="text-slate-400 text-sm" data-id="element-717">
              You fund your own ad spend directly. We never mark up your
              advertising budget.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 3. SERVICE TIERS */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto border-t border-slate-800/50 mb-20" data-id="element-718">
        <div className="text-center mb-16" data-id="element-719">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-720">
            Service Tiers
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-721">
            Choose how you want to handle the candidates we generate.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch" data-id="element-722">
          {/* Pass-Through Tier */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-900/30 border border-slate-800 rounded-3xl p-8 md:p-10 flex flex-col" data-id="element-723">
            <div className="mb-8" data-id="element-724">
              <h3 className="text-3xl font-bold text-white mb-4" data-id="element-725">
                Pass-Through
              </h3>
              <p className="text-slate-400 text-lg" data-id="element-726">
                Basic screening and direct candidate access.
              </p>
            </div>

            <div className="space-y-4 mb-10 flex-1" data-id="element-727">
              <div className="flex items-start" data-id="element-728">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-729" />
                <span className="text-slate-300" data-id="element-730">
                  Basic candidate screening applied
                </span>
              </div>
              <div className="flex items-start" data-id="element-731">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-732" />
                <span className="text-slate-300" data-id="element-733">
                  Direct access to all applicants
                </span>
              </div>
              <div className="flex items-start" data-id="element-734">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-735" />
                <span className="text-slate-300" data-id="element-736">
                  You handle all interviews
                </span>
              </div>
              <div className="flex items-start" data-id="element-737">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-738" />
                <span className="text-slate-300" data-id="element-739">
                  You manage the hiring process
                </span>
              </div>
            </div>

            <div className="pt-8 border-t border-slate-800" data-id="element-740">
              <p className="text-sm text-slate-500" data-id="element-741">
                Very simple: we generate the flow, you take it from there.
              </p>
            </div>
          </motion.div>

          {/* Headhunting Tier */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-800/50 border border-[#7FE0C3]/50 ring-1 ring-[#7FE0C3]/20 rounded-3xl p-8 md:p-10 flex flex-col relative shadow-2xl" data-id="element-742">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1.5 bg-[#7FE0C3] text-[#163A5F] text-sm font-bold uppercase tracking-wider rounded-full flex items-center space-x-2" data-id="element-743">
              <Crown className="w-4 h-4" data-id="element-744" />
              <span data-id="element-745">Full Service</span>
            </div>

            <div className="mb-8 mt-2" data-id="element-746">
              <h3 className="text-3xl font-bold text-white mb-4" data-id="element-747">
                Headhunting
              </h3>
              <p className="text-slate-300 text-lg" data-id="element-748">
                Full interview process through hiring and onboarding.
              </p>
            </div>

            <div className="space-y-4 mb-10 flex-1" data-id="element-749">
              <div className="flex items-start" data-id="element-750">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-751" />
                <span className="text-slate-200" data-id="element-752">
                  First, second, and third round interviews
                </span>
              </div>
              <div className="flex items-start" data-id="element-753">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-754" />
                <span className="text-slate-200" data-id="element-755">
                  Candidates sold on the vision
                </span>
              </div>
              <div className="flex items-start" data-id="element-756">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-757" />
                <span className="text-slate-200" data-id="element-758">
                  Integrated into our scaling system
                </span>
              </div>
              <div className="flex items-start" data-id="element-759">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-760" />
                <span className="text-slate-200" data-id="element-761">
                  Aligned to building the team through HIRE
                </span>
              </div>
              <div className="flex items-start" data-id="element-762">
                <Check className="w-6 h-6 text-[#7FE0C3] mr-3 shrink-0" data-id="element-763" />
                <span className="text-slate-200" data-id="element-764">
                  Ready to say yes and start
                </span>
              </div>
            </div>

            <div className="pt-8 border-t border-[#7FE0C3]/20 bg-[#7FE0C3]/5 -mx-8 md:-mx-10 -mb-8 md:-mb-10 p-8 md:p-10 rounded-b-3xl" data-id="element-765">
              <div className="flex items-center space-x-3 mb-4" data-id="element-766">
                <DollarSign className="w-6 h-6 text-[#7FE0C3]" data-id="element-767" />
                <h4 className="text-xl font-bold text-white" data-id="element-768">
                  Performance Pricing
                </h4>
              </div>
              <p className="text-2xl font-bold text-[#7FE0C3] mb-2" data-id="element-769">
                2.5% of Revenue
              </p>
              <p className="text-slate-300 mb-4" data-id="element-770">
                Up to $1,000,000, paid out at each $100,000 benchmark.
              </p>
              <div className="bg-slate-900/50 border border-slate-700/50 rounded-lg p-4" data-id="element-771">
                <p className="text-sm text-slate-400 flex items-start" data-id="element-772">
                  <ArrowRight className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-773" />
                  <span data-id="element-774">
                    Based on what that person's <strong data-id="element-775">TEAM</strong> produces,
                    not what they are doing individually.
                  </span>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}